(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sunrise1-sleep-scenes"] && !Shopify.designMode) return;
  try {
    
/* Native touch scrolling works even without JavaScript. This element adds
   mouse dragging, keyboard navigation, and theme-editor block selection. */
if (!customElements.get('sunrise1-scenes-swipe')) {
  customElements.define('sunrise1-scenes-swipe', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.drag = null;
      this.suppressClickUntil = 0;

      this.addEventListener('pointerdown', (event) => this.startDrag(event), { signal });
      window.addEventListener('pointermove', (event) => this.moveDrag(event), { passive: false, signal });
      window.addEventListener('pointerup', (event) => this.endDrag(event), { signal });
      window.addEventListener('pointercancel', (event) => this.endDrag(event), { signal });
      window.addEventListener('blur', () => this.endDrag(), { signal });
      this.addEventListener('lostpointercapture', (event) => this.endDrag(event), { signal });
      this.addEventListener('dragstart', (event) => {
        if (this.mobile.matches) event.preventDefault();
      }, { signal });
      this.addEventListener('selectstart', (event) => {
        if (this.drag) event.preventDefault();
      }, { signal });
      this.addEventListener('click', (event) => {
        if (event.detail !== 0 && performance.now() < this.suppressClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal });
      this.addEventListener('keydown', (event) => this.onKeyDown(event), { signal });
      this.mobile.addEventListener('change', () => {
        this.endDrag();
        if (!this.mobile.matches) this.scrollLeft = 0;
      }, { signal });
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.mobile.matches || !(event.target instanceof Element)) return;
        const card = event.target.closest('.s1-scene');
        if (card && this.contains(card)) this.goTo(this.cards.indexOf(card), false);
      }, { signal });
    }

    disconnectedCallback() {
      if (this.events) this.events.abort();
      this.events = null;
      this.drag = null;
      delete this.dataset.dragging;
    }

    get cards() {
      return Array.from(this.children).filter((item) => item.classList.contains('s1-scene'));
    }

    get positions() {
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).paddingLeft) || 0;
      const limit = Math.max(0, this.scrollWidth - this.clientWidth);
      return this.cards.map((card) => Math.max(0, Math.min(limit,
        card.getBoundingClientRect().left - rect.left + this.scrollLeft - this.clientLeft - padding
      )));
    }

    nearestIndex() {
      const positions = this.positions;
      return positions.reduce((best, position, index) =>
        Math.abs(position - this.scrollLeft) < Math.abs(positions[best] - this.scrollLeft) ? index : best, 0);
    }

    goTo(index, animate = true) {
      const positions = this.positions;
      if (!positions.length) return;
      const target = Math.max(0, Math.min(index, positions.length - 1));
      this.scrollTo({
        left: positions[target],
        behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'instant'
      });
    }

    startDrag(event) {
      // Leave touch input to the browser: retain vertical scrolling and pinch zoom.
      if (!this.mobile.matches || event.pointerType !== 'mouse' || !event.isPrimary || event.button !== 0) return;
      if (this.scrollWidth <= this.clientWidth + 1) return;
      if (event.target.closest('a, button, input, textarea, select, [contenteditable="true"]')) return;
      this.suppressClickUntil = 0;
      this.drag = {
        id: event.pointerId, x: event.clientX, y: event.clientY,
        left: this.scrollLeft, startIndex: this.nearestIndex(), delta: 0, active: false
      };
    }

    moveDrag(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.active) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
        drag.active = true;
        this.dataset.dragging = 'true';
        // Disable snapping before applying pixel-by-pixel movement.
        try { this.setPointerCapture(event.pointerId); } catch (_) { /* Pointer may already be released. */ }
      }
      if (event.cancelable) event.preventDefault();
      drag.delta = dx;
      this.scrollLeft = drag.left - dx;
    }

    endDrag(event) {
      const drag = this.drag;
      if (!drag || (event && event.pointerId !== drag.id)) return;
      this.drag = null;
      let target = this.nearestIndex();
      if (drag.active && target === drag.startIndex && Math.abs(drag.delta) >= 40) {
        target += drag.delta < 0 ? 1 : -1;
      }
      delete this.dataset.dragging;
      if (this.hasPointerCapture(drag.id)) this.releasePointerCapture(drag.id);
      if (drag.active) {
        this.suppressClickUntil = performance.now() + 350;
        this.goTo(target);
      }
    }

    onKeyDown(event) {
      if (!this.mobile.matches || event.target !== this || event.altKey || event.ctrlKey || event.metaKey) return;
      let target = this.nearestIndex();
      switch (event.key) {
        case 'ArrowRight': target += 1; break;
        case 'ArrowLeft': target -= 1; break;
        case 'Home': target = 0; break;
        case 'End': target = this.cards.length - 1; break;
        default: return;
      }
      event.preventDefault();
      this.goTo(target);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunrise1-sleeper-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const elementName = 'dreamegg-sunrise-reviews';
  if (customElements.get(elementName)) return;

  // Keep the chosen review visible when the theme editor re-renders this section.
  // This state is not persisted for storefront visitors.
  const editorState = new Map();

  class DreameggSunriseReviews extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.initialize());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.layoutFrame);
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.initialized = false;
      this.drag = null;
    }

    initialize() {
      if (!this.isConnected || this.initialized) return;
      this.viewport = this.querySelector('[data-review-viewport]');
      this.track = this.querySelector('[data-review-track]');
      this.tablist = this.querySelector('[role="tablist"]');
      this.tabs = Array.from(this.querySelectorAll('[role="tab"][data-review-key]'));
      this.panels = Array.from(this.querySelectorAll('[data-review-panel]'));
      if (!this.viewport || !this.track || !this.tablist || !this.panels.length) return;
      this.initialized = true;
      this.events = new AbortController();
      const listen = (target, name, handler, options = {}) => {
        target?.addEventListener(name, handler, { ...options, signal: this.events.signal });
      };
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.isEditor = this.dataset.editor === 'true';
      this.centerActive = this.dataset.centerActive !== 'false';
      this.defaultKey = this.dataset.defaultReview || '1';
      this.previousButton = this.querySelector('[data-review-prev]');
      this.nextButton = this.querySelector('[data-review-next]');
      this.counter = this.querySelector('[data-review-counter]');
      this.status = this.querySelector('[data-review-status]');
      this.dataset.ready = 'true';

      const saved = this.isEditor ? editorState.get(this.id) : null;
      const startingKey = saved?.defaultKey === this.defaultKey ? saved.key : this.defaultKey;
      this.selectReview(startingKey, { animate: false });

      listen(this.tablist, 'click', event => {
        const tab = event.target.closest('[role="tab"][data-review-key]');
        if (tab && this.tablist.contains(tab)) this.selectReview(tab.dataset.reviewKey, { announce: true });
      });
      listen(this.tablist, 'keydown', event => this.onTabKeydown(event));
      listen(this.previousButton, 'click', () => this.step(-1));
      listen(this.nextButton, 'click', () => this.step(1));
      listen(this.viewport, 'pointerdown', event => this.onPointerDown(event));
      listen(this.viewport, 'pointermove', event => this.onPointerMove(event));
      listen(this.viewport, 'pointerup', event => this.onPointerEnd(event, false));
      listen(this.viewport, 'pointercancel', event => this.onPointerEnd(event, true));
      listen(this.viewport, 'dragstart', event => event.preventDefault());
      listen(this.viewport, 'click', event => {
        if (performance.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { capture: true });
      listen(this.viewport, 'wheel', event => this.onWheel(event), { passive: false });
      listen(window, 'resize', () => this.scheduleLayout());
      listen(this, 'shopify:block:select', event => {
        const tab = this.tabs.find(item => item.dataset.blockId === String(event.detail?.blockId));
        if (tab) this.selectReview(tab.dataset.reviewKey, { animate: false });
      });
      listen(this, 'load', () => this.scheduleLayout(), { capture: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
        this.panels.forEach(panel => this.resizeObserver.observe(panel));
        this.resizeObserver.observe(this.viewport);
      }
      this.scheduleLayout();
    }

    selectReview(key, { animate = true, announce = false } = {}) {
      const requested = this.panels.findIndex(panel => panel.dataset.reviewPanel === String(key));
      this.index = requested < 0 ? 0 : requested;
      const activePanel = this.panels[this.index];
      this.activeKey = activePanel.dataset.reviewPanel;
      this.dataset.activeReview = this.activeKey;
      this.panels.forEach((panel, index) => {
        const active = index === this.index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', String(!active));
        panel.toggleAttribute('inert', !active);
        panel.tabIndex = active ? 0 : -1;
        const tab = this.tabs.find(item => item.dataset.reviewKey === panel.dataset.reviewPanel);
        if (tab) {
          panel.setAttribute('aria-labelledby', tab.id);
          panel.removeAttribute('aria-label');
        }
      });
      this.tabs.forEach(tab => {
        const active = tab.dataset.reviewKey === this.activeKey;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.placeActiveStatInCenter();
      this.setTrackPosition(0, animate);
      this.updateHeight();
      if (this.previousButton) this.previousButton.disabled = this.index === 0;
      if (this.nextButton) this.nextButton.disabled = this.index === this.panels.length - 1;
      if (this.counter) this.counter.textContent = `${this.index + 1} / ${this.panels.length}`;
      if (announce && this.status) {
        this.status.textContent = `${activePanel.dataset.author || ''} — ${this.index + 1} / ${this.panels.length}`;
      }
      if (this.isEditor) {
        editorState.set(this.id, { key: this.activeKey, defaultKey: this.defaultKey });
      }
    }

    placeActiveStatInCenter() {
      if (!this.centerActive || this.tabs.length !== 3) return;
      if (new Set(this.tabs.map(tab => tab.dataset.reviewKey)).size !== 3) return;
      const selected = this.tabs.find(tab => tab.dataset.reviewKey === this.activeKey);
      if (!selected) return;
      const others = this.tabs.filter(tab => tab !== selected)
        .sort((a, b) => Number(a.dataset.reviewKey) - Number(b.dataset.reviewKey));
      const desired = [others[0], selected, others[1]];
      const current = Array.from(this.tablist.children);
      if (desired.every((tab, index) => current[index] === tab)) return;
      // Move the actual nodes so visual, DOM and keyboard orders remain consistent.
      const focused = this.tablist.contains(document.activeElement) ? document.activeElement : null;
      desired.forEach(tab => this.tablist.appendChild(tab));
      focused?.focus({ preventScroll: true });
    }

    onTabKeydown(event) {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const ordered = Array.from(this.tablist.querySelectorAll('[role="tab"]'));
      const current = ordered.indexOf(event.target.closest('[role="tab"]'));
      if (current < 0) return;
      event.preventDefault();
      let next = current;
      if (event.key === 'ArrowLeft') next = (current - 1 + ordered.length) % ordered.length;
      if (event.key === 'ArrowRight') next = (current + 1) % ordered.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = ordered.length - 1;
      const tab = ordered[next];
      this.selectReview(tab.dataset.reviewKey, { announce: true });
      tab.focus({ preventScroll: true });
    }

    step(direction) {
      const next = Math.max(0, Math.min(this.panels.length - 1, this.index + direction));
      this.selectReview(this.panels[next].dataset.reviewPanel, { announce: next !== this.index });
    }

    setTrackPosition(delta = 0, animate = false) {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const renderedWidth = this.viewport.getBoundingClientRect().width;
      const layoutWidth = parseFloat(getComputedStyle(this.viewport).width) || renderedWidth;
      // Percentages use the same layout width as the 100%-wide slides.
      // Convert pointer movement from screen pixels when the editor preview is scaled.
      const dragOffset = renderedWidth > 0 ? delta * layoutWidth / renderedWidth : delta;
      const extraOffset = dragOffset - this.index * gap;
      this.track.style.transition = animate && !this.reducedMotion.matches ? 'transform 320ms ease' : 'none';
      this.track.style.transform = `translate3d(calc(${-this.index * 100}% + ${extraOffset}px), 0, 0)`;
    }

    updateHeight() {
      const activePanel = this.panels[this.index];
      // Read layout height, not an ancestor-transform-scaled screen rectangle.
      const height = Math.ceil(parseFloat(getComputedStyle(activePanel).height) || activePanel.offsetHeight);
      if (height > 0 && this.viewport.style.height !== `${height}px`) this.viewport.style.height = `${height}px`;
    }

    scheduleLayout() {
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => {
        if (!this.isConnected || !this.initialized) return;
        this.updateHeight();
        // Do not interrupt a swipe or reset an in-progress slide transition.
        const width = parseFloat(getComputedStyle(this.viewport).width) || this.viewport.clientWidth;
        if (Math.abs(width - (this.lastWidth || 0)) > .01) {
          this.lastWidth = width;
          this.drag = null;
          delete this.dataset.dragging;
          this.setTrackPosition(0, false);
        }
      });
    }

    onPointerDown(event) {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      if (event.target.closest('a, button, input, textarea, select')) return;
      this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, delta: 0, horizontal: false };
    }

    onPointerMove(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.horizontal) {
        if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { this.drag = null; return; }
        if (Math.abs(dx) < 10 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        drag.horizontal = true;
        this.dataset.dragging = 'true';
        try { this.viewport.setPointerCapture(event.pointerId); } catch (_) { /* Synthetic events have no active pointer. */ }
      }
      if (event.cancelable) event.preventDefault();
      drag.delta = dx;
      const atEdge = (this.index === 0 && dx > 0) || (this.index === this.panels.length - 1 && dx < 0);
      const width = this.viewport.getBoundingClientRect().width;
      const bounded = Math.max(-width * .9, Math.min(width * .9, dx));
      this.setTrackPosition(atEdge ? bounded * .2 : bounded, false);
    }

    onPointerEnd(event, cancelled) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      this.drag = null;
      delete this.dataset.dragging;
      if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
      if (!drag.horizontal) return;
      this.suppressClickUntil = performance.now() + 250;
      const threshold = Math.max(32, Math.min(80, this.viewport.getBoundingClientRect().width * .12));
      if (!cancelled && Math.abs(drag.delta) >= threshold) this.step(drag.delta < 0 ? 1 : -1);
      else this.setTrackPosition(0, true);
    }

    onWheel(event) {
      // Trackpad horizontal gestures only; ordinary vertical scrolling stays native.
      if (Math.abs(event.deltaX) < 3 || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      const direction = event.deltaX > 0 ? 1 : -1;
      if ((this.index === 0 && direction < 0) || (this.index === this.panels.length - 1 && direction > 0)) return;
      event.preventDefault();
      const now = performance.now();
      if (now < (this.wheelCooldown || 0)) return;
      if (now - (this.lastWheelTime || 0) > 180) this.wheelDelta = 0;
      this.lastWheelTime = now;
      this.wheelDelta = (this.wheelDelta || 0) + event.deltaX;
      if (Math.abs(this.wheelDelta) >= 50) {
        this.step(this.wheelDelta > 0 ? 1 : -1);
        this.wheelDelta = 0;
        this.wheelCooldown = now + 420;
      }
    }
  }

  customElements.define(elementName, DreameggSunriseReviews);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunrise1-unwind-sounds"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tagName = 'sunrise1-sound-cards';
  if (customElements.get(tagName)) return;

  class Sunrise1SoundCards extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.abortController) return;
      this.scroller = this.querySelector('[data-sound-scroller]');
      if (!this.scroller) return;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.notice = this.querySelector('[data-sound-notice]');
      this.records = new Map();
      this.ignoreClickUntil = 0;
      this.querySelectorAll('[data-sound-card]').forEach((card) => {
        const audio = card.querySelector('[data-sound-audio]');
        const button = card.querySelector('[data-sound-toggle]');
        if (!audio || !button) return;
        const record = { card, audio, button, wanted: false, request: 0 };
        this.records.set(card, record);
        button.disabled = false;
        audio.addEventListener('playing', () => {
          if (!record.wanted) { audio.pause(); return; }
          this.setState(record, 'playing');
        }, { signal });
        audio.addEventListener('pause', () => {
          if (!audio.paused) return;
          record.wanted = false;
          record.request += 1;
          if (card.dataset.audioState !== 'error') this.setState(record, 'idle');
        }, { signal });
        audio.addEventListener('ended', () => {
          record.wanted = false;
          this.setState(record, 'idle');
        }, { signal });
        audio.addEventListener('error', () => {
          if (record.wanted) this.showError(record);
        }, { signal });
      });
      this.setAttribute('data-audio-ready', '');
      this.scroller.addEventListener('click', (event) => this.onClick(event), { signal, capture: true });
      this.scroller.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal, passive: true });
      window.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal, passive: false });
      window.addEventListener('pointerup', (event) => this.finishGesture(event), { signal });
      window.addEventListener('pointercancel', (event) => this.finishGesture(event), { signal });
      this.scroller.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
      this.scroller.addEventListener('keydown', (event) => this.onKeyDown(event), { signal });
      // Pause only other instances of this sound-preview module, not unrelated site media.
      document.addEventListener('sunrise1:sound-play', (event) => this.pauseAll(event.detail.audio), { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pauseAll();
      }, { signal });
      window.addEventListener('pagehide', () => this.pauseAll(), { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-sound-card]');
        if (card && this.contains(card) && this.isScrollable()) {
          card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
        }
      }, { signal });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.pauseAll();
      if (this.abortController) this.abortController.abort();
      this.abortController = null;
      this.gesture = null;
      this.removeAttribute('data-audio-ready');
      this.removeAttribute('data-sound-dragging');
    }

    setState(record, state) {
      record.card.dataset.audioState = state;
      const active = state === 'playing' || state === 'loading';
      record.button.setAttribute('aria-pressed', String(active));
      record.button.setAttribute('aria-busy', String(state === 'loading'));
      const label = active ? this.dataset.audioPause : this.dataset.audioPlay;
      record.button.setAttribute('aria-label', `${label}: ${record.card.dataset.audioName}`);
    }

    pause(record, reset = false) {
      record.request += 1;
      record.wanted = false;
      record.audio.pause();
      if (reset) {
        try { record.audio.currentTime = 0; } catch (_) { /* No media metadata yet. */ }
      }
      this.setState(record, 'idle');
    }

    pauseAll(exceptAudio) {
      if (!this.records) return;
      this.records.forEach((record) => {
        if (record.audio !== exceptAudio) this.pause(record, true);
      });
    }

    showError(record) {
      this.pause(record);
      record.card.dataset.audioState = 'error';
      if (this.notice) {
        this.notice.textContent = `${record.card.dataset.audioName}: ${this.dataset.audioError}`;
        this.notice.hidden = false;
      }
    }

    toggle(record) {
      if (record.wanted || !record.audio.paused) { this.pause(record); return; }
      if (this.notice) { this.notice.hidden = true; this.notice.textContent = ''; }
      document.dispatchEvent(new CustomEvent('sunrise1:sound-play', { detail: { audio: record.audio } }));
      if (record.audio.error) record.audio.load();
      if (record.audio.ended) record.audio.currentTime = 0;
      const request = ++record.request;
      record.wanted = true;
      this.setState(record, 'loading');
      try {
        // Call play() directly within the click gesture for mobile browser permission.
        const promise = record.audio.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(() => {
            if (this.isConnected && request === record.request && record.wanted) this.showError(record);
          });
        }
      } catch (_) { this.showError(record); }
    }

    onClick(event) {
      // A swipe/drag must never also activate a card or its legacy link.
      if (event.detail !== 0 && performance.now() < this.ignoreClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      const control = event.target.closest('a, button, input, select, textarea, [role="button"]');
      if (control && !control.matches('[data-sound-toggle]')) return;
      const card = event.target.closest('[data-sound-card]');
      const record = card && this.records.get(card);
      if (!record) return;
      event.preventDefault();
      this.toggle(record);
    }

    isScrollable() {
      return this.scroller && this.scroller.scrollWidth > this.scroller.clientWidth + 2;
    }

    onPointerDown(event) {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      this.ignoreClickUntil = 0;
      this.gesture = {
        id: event.pointerId, x: event.clientX, y: event.clientY,
        scroll: this.scroller.scrollLeft, mouse: event.pointerType === 'mouse',
        moved: false, dragging: false
      };
    }

    onPointerMove(event) {
      const gesture = this.gesture;
      if (!gesture || gesture.id !== event.pointerId) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) gesture.moved = true;
      // Touch stays fully native: allow both horizontal cards and vertical page scroll.
      if (!gesture.mouse || !this.isScrollable()) return;
      if (!gesture.dragging && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
        gesture.dragging = true;
        this.setAttribute('data-sound-dragging', '');
        try { this.scroller.setPointerCapture(event.pointerId); } catch (_) { /* Pointer ended. */ }
      }
      if (gesture.dragging) {
        event.preventDefault();
        this.scroller.scrollLeft = gesture.scroll - dx;
      }
    }

    finishGesture(event) {
      const gesture = this.gesture;
      if (!gesture || gesture.id !== event.pointerId) return;
      if (gesture.moved || event.type === 'pointercancel') this.ignoreClickUntil = performance.now() + 500;
      if (gesture.dragging) {
        try { this.scroller.releasePointerCapture(event.pointerId); } catch (_) { /* Already released. */ }
        this.removeAttribute('data-sound-dragging');
      }
      this.gesture = null;
    }

    onKeyDown(event) {
      if (event.target !== this.scroller || !this.isScrollable()) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const first = this.scroller.querySelector('[data-sound-card]');
      if (!first) return;
      const gap = parseFloat(getComputedStyle(this.scroller).columnGap) || 0;
      const step = first.getBoundingClientRect().width + gap;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (event.key === 'Home' || event.key === 'End') {
        this.scroller.scrollTo({ left: event.key === 'Home' ? 0 : this.scroller.scrollWidth, behavior });
      } else {
        this.scroller.scrollBy({ left: event.key === 'ArrowRight' ? step : -step, behavior });
      }
    }
  }
  customElements.define(tagName, Sunrise1SoundCards);
})();

  } catch(e) { console.error(e); }
})();
})();
